const SPARKLES = [
    { top: "18%", left: "72%", size: 6, delay: "0s" },
    { top: "34%", left: "88%", size: 4, delay: "0.8s" },
    { top: "62%", left: "58%", size: 5, delay: "1.4s" },
    { top: "78%", left: "82%", size: 4, delay: "0.3s" },
    { top: "52%", left: "14%", size: 3, delay: "1.1s" },
    { top: "28%", left: "42%", size: 3, delay: "1.8s" },
];

/** Option 2 — Ambient Brand Mesh: soft color atmosphere + grain + sparkles */
export const HeroBackgroundMesh = () => (
    <>
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-white via-brand-surface/30 to-white" />

        {/* Mesh blobs */}
        <div
            className="hero-mesh-blob pointer-events-none absolute -bottom-40 -left-32 h-[min(560px,70vw)] w-[min(560px,70vw)] rounded-full bg-[radial-gradient(closest-side,rgba(6,78,87,0.2),rgba(6,78,87,0.06)_45%,transparent_72%)] blur-3xl"
            aria-hidden="true"
        />
        <div
            className="hero-mesh-blob hero-mesh-blob--gold pointer-events-none absolute -right-28 -top-20 h-[min(520px,65vw)] w-[min(520px,65vw)] rounded-full bg-[radial-gradient(closest-side,rgba(253,185,39,0.24),rgba(253,185,39,0.07)_42%,transparent_70%)] blur-3xl"
            aria-hidden="true"
        />
        <div
            className="pointer-events-none absolute left-[38%] top-[32%] hidden h-[520px] w-[520px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(closest-side,rgba(234,242,241,0.95),rgba(244,248,247,0.4)_50%,transparent_75%)] blur-2xl lg:block"
            aria-hidden="true"
        />
        <div
            className="pointer-events-none absolute right-[8%] top-[48%] hidden h-[420px] w-[420px] rounded-full bg-[radial-gradient(closest-side,rgba(6,78,87,0.08),transparent_68%)] blur-2xl lg:block"
            aria-hidden="true"
        />

        {/* Mobile — ambient band fills lower void */}
        <div
            className="pointer-events-none absolute inset-x-0 bottom-0 h-[min(46%,420px)] bg-gradient-to-t from-brand-mist/90 via-brand-surface/55 to-transparent lg:hidden"
            aria-hidden="true"
            data-testid="hero-mesh-mobile-band"
        />
        <div
            className="pointer-events-none absolute inset-x-0 bottom-0 h-[min(38%,340px)] bg-[radial-gradient(ellipse_90%_80%_at_50%_100%,rgba(253,185,39,0.12)_0%,transparent_70%)] lg:hidden"
            aria-hidden="true"
        />

        {/* Grain texture */}
        <div className="hero-grain pointer-events-none absolute inset-0 opacity-[0.045]" aria-hidden="true" />

        {/* Content-safe wash — keeps headline crisp */}
        <div
            className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_75%_65%_at_28%_38%,rgba(255,255,255,0.82)_0%,transparent_62%)]"
            aria-hidden="true"
        />

        {/* Sparkle dots */}
        {SPARKLES.map((s) => (
            <span
                key={`${s.top}-${s.left}`}
                className="sparkle-pulse pointer-events-none absolute rounded-full bg-brand-gold"
                style={{
                    top: s.top,
                    left: s.left,
                    width: s.size,
                    height: s.size,
                    animationDelay: s.delay,
                    opacity: 0.45,
                }}
                aria-hidden="true"
            />
        ))}
    </>
);
